export const getStyles = () => ({
  container: {
    minWidth: 320,
    maxWidth: 1366,
    boxSizing: 'border-box',
    margin: '0 auto',
    fontFamily: '"Segoe UI", "Segoe UI Web (West European)", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
  },
  largeDesktopContainer: {
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    marginLeft: 'auto',
    marginRight: 'auto',
    alignContent: 'center',
  },
});
